import { ExternalLink } from "lucide-react";
import { GITHUB_URL } from "../../lib/links";
import { BrandMark } from "../ui/BrandMark";
import { GithubMark } from "../ui/GithubMark";

export function OpenSourceBanner() {
  return (
    <div className="panel oss-banner">
      <div className="oss-banner-copy">
        <span className="oss-banner-icon">
          <BrandMark size={28} />
        </span>
        <div>
          <h2 className="oss-banner-title">Open source, always.</h2>
          <p className="oss-banner-body">WOVEN remains under Apache 2.0 and free to self-host.</p>
        </div>
      </div>
      <a href={GITHUB_URL} target="_blank" rel="noreferrer" className="btn btn--ghost">
        <GithubMark size={16} />
        View on GitHub
        <ExternalLink size={16} strokeWidth={2} absoluteStrokeWidth aria-hidden="true" />
      </a>
    </div>
  );
}
